class NotifyWhenAvailable {
  constructor() {
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    // Handle form submissions
    document.addEventListener('submit', (e) => {
      if (e.target.matches('[data-notify-form]')) {
        e.preventDefault();
        this.handleFormSubmit(e.target);
      }
    });

    // Handle variant changes to update the form
    document.addEventListener('variant:change', (e) => {
      this.updateVariantId(e.detail.variant.id);
    });
  }

  async handleFormSubmit(form) {
    const formData = new FormData(form);
    const emailRaw = formData.get('email');
    const email = typeof emailRaw === 'string' ? emailRaw.trim() : '';
    const productId = formData.get('product_id');
    const productTitle = formData.get('product_title');
    const productUrl = formData.get('product_url');
    const enableKlaviyoFlow = formData.get('enable_klaviyo_flow') === 'true';
    const klaviyoFlowId = formData.get('klaviyo_flow_id');

    // Validate email presence
    if (!email) {
      this.showMessage(form, 'error', 'Please enter your email address.');
      return;
    }

    // Validate email format
    if (!this.isValidEmail(email)) {
      this.showMessage(form, 'error', 'Please enter a valid email address.');
      return;
    }

    // Validate flow ID only when Klaviyo flow is enabled
    if (enableKlaviyoFlow && (!klaviyoFlowId || klaviyoFlowId.trim() === '')) {
      this.showMessage(form, 'error', 'This form is not configured. Please add a Klaviyo Flow ID in the block settings.');
      return;
    }

    // Disable form during submission
    const submitButton = form.querySelector('.notify-when-available__button');
    const originalText = submitButton.textContent;
    submitButton.disabled = true;
    submitButton.textContent = 'Submitting...';

    try {
      // Submit to back-in-stock API (Klaviyo flow optional)
      await this.trackKlaviyoBackInStock(email, productId, productTitle, productUrl, enableKlaviyoFlow ? klaviyoFlowId : null);
      
      // Show success message after successful Klaviyo subscription
      this.showMessage(form, 'success');
      
      // Hide the input form and show thank you message in its place
      this.hideFormAndShowThankYou(form);
      
    } catch (error) {
      // Show error message if Klaviyo subscription failed
      this.showMessage(form, 'error', 'Something went wrong. Please try again.');
    } finally {
      // Re-enable form
      submitButton.disabled = false;
      submitButton.textContent = originalText;
    }
  }

  async trackKlaviyoBackInStock(email, productId, productTitle, productUrl, klaviyoFlowId) {
    // Get the default variant ID from the product form
    let currentVariantId = productId; // fallback to product ID
    
    // Try to get the currently selected variant
    const variantSelect = document.querySelector('[name="id"]');
    if (variantSelect) {
      currentVariantId = variantSelect.value;
    }
    
    // If no variant is selected or it's the same as product ID, try to get the first available variant
    if (!currentVariantId || currentVariantId === productId) {
      // Look for checked radio buttons first
      const checkedVariant = document.querySelector('input[name="id"]:checked');
      if (checkedVariant) {
        currentVariantId = checkedVariant.value;
      } else {
        // Look for the first option in a select
        const firstOption = document.querySelector('select[name="id"] option:first-child');
        if (firstOption) {
          currentVariantId = firstOption.value;
        } else {
          // Look for any input with name="id" that has a value
          const anyVariant = document.querySelector('input[name="id"][value]');
          if (anyVariant) {
            currentVariantId = anyVariant.value;
          }
        }
      }
    }
    
    const subscriptionData = {
      email: email,
      variant_id: currentVariantId
    };

    const TOKEN = "1513a052fb8349fa22d3b128e7bceab5a1897063cf6ff80ccb831d86c1bbb9e09b4934b13d6bc9053393a9abc03ea2656e254cc27b12d92bf41f09d6fe0df21223fe8cbe62137ca0f394861762871f4043ba303fc74adb7bc68ef91830e0e78ed08d47aff8f6a59269d3bf41f0d271da3d1227c03f733f2a7af0862d6c623972";
    try {
      const response = await fetch("https://services.drinkbrez.com/api/bis/subscribe", {
        method: "POST",
        headers: { 
          "Content-Type": "application/json" ,
          "Authorization": "Bearer " + TOKEN
        },
        body: JSON.stringify(subscriptionData)
      });

      if (response.ok) {
        const responseData = await response.json();
      } else {
        const errorData = await response.text();
        throw new Error(`API error: ${response.status}`);
      }
    } catch (error) {
      throw error;
    }
  }

  updateVariantId(variantId) {
    // No longer needed since we're working at product level
    // This function is kept for compatibility but does nothing
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  showMessage(form, type, customMessage) {
    // Hide all messages first
    const messages = form.parentElement.querySelectorAll('.notify-when-available__message');
    messages.forEach(message => {
      message.style.display = 'none';
    });

    // Show the appropriate message
    const message = form.parentElement.querySelector(`.notify-when-available__message--${type}`);
    if (message) {
      if (type === 'error' && typeof customMessage === 'string') {
        message.textContent = customMessage;
      }
      message.style.display = 'block';
    }
  }

  hideFormAndShowThankYou(form) {
    // Hide the input form elements
    const inputGroup = form.querySelector('.notify-when-available__input-group');
    const heading = form.querySelector('.notify-when-available__heading');
    const description = form.querySelector('.notify-when-available__description');
    
    if (inputGroup) inputGroup.style.display = 'none';
    if (heading) heading.style.display = 'none';
    if (description) description.style.display = 'none';
    
    // Show the success message
    const successMessage = form.parentElement.querySelector('.notify-when-available__message--success');
    if (successMessage) {
      successMessage.style.display = 'block';
      successMessage.style.textAlign = 'center';
      successMessage.style.padding = '20px';
    }
    
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new NotifyWhenAvailable();
  });
} else {
  new NotifyWhenAvailable();
}
